import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MyPaymentProviderItem
  from 'components/dashboard/settings-content/commerce/MyPaymentProviderItem';

import './MyPaymentProvidersList.css';

function MyPaymentProvidersList(props) {
  const { paymentProviders } = props;
  const { t } = useTranslation();

  if (paymentProviders && paymentProviders.length === 0) return null;

  return (
    <div className="my-payment-providers-list__component">
      <div className="title">{t("My payment providers")}</div>

      {paymentProviders && paymentProviders.map(item => (
        <MyPaymentProviderItem item={item} />
      ))}

    </div>
  );
}

MyPaymentProvidersList.propTypes = {
  paymentProviders: PropTypes.arrayOf(PropTypes.shape),
};

MyPaymentProvidersList.defaultProps = {
  paymentProviders: null,
};

export default MyPaymentProvidersList;
